import { BehaviorSubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ShareMode } from '@shared/config/navigation.config';

@Injectable()
export class ScreenshotPublisherService {
  private prepareForScreenshot = new BehaviorSubject<boolean>(false);
  public prepareForScreenshot$ = this.prepareForScreenshot.asObservable();

  private takeScreenShot = new Subject<ShareMode>();
  public takeScreenShot$ = this.takeScreenShot.asObservable();

  public takeScreenshot(mode: ShareMode) {
    this.takeScreenShot.next(mode);
  }

  public publish(prepareForScreenshot: boolean) {
    this.prepareForScreenshot.next(prepareForScreenshot);
  }
}
